module.exports = __webpack_public_path__ + "img/friend-space_en.a8367672.png";